import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-270c1fec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "textContent"]

interface Props {
  emoji: string;
  text: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserStatusIcon',
  props: {
    emoji: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      title: _ctx.text,
      textContent: _toDisplayString(_ctx.emoji)
    }, null, 8, _hoisted_1)
  ]))
}
}

})